import utilsConstants from './config/config.utils';

const moment = require('moment');
require('moment/locale/es');

moment.locale('es');

function calculateDefaultTimeLimit(startDate, disabledDays){
  const timeLimitDefault = addDays(startDate, utilsConstants.MIN_TIMELIMIT, 0);
  timeLimitDefault.setHours(0,0,0,0);
  timeLimitDefault.setUTCHours(4);

  const dateHolidays = stringToDate(disabledDays, 4 , true, false);
  return findEnabledDay(timeLimitDefault, dateHolidays);
}

function findEnabledDay(day, disabledDays){
  if(disabledDays.includes(day.getTime())){
    return findEnabledDay(addDays(day, 1, 4),disabledDays);
  }else{
    return day;
  }
}

function getHolidaysDefault(start, end){
  var holidays = [];
  var init = addDays(start, 1, 0);
  while(init < end){
    holidays.push(new Date(init));
    init.setDate( init.getDate() + 1 );
  }
  return holidays;
}

function countDays(startDate, endDate, inhabiles) {

  const y = moment(endDate);

  startDate.setHours(0,0,0,0);
  endDate.setHours(0,0,0,0)

  const miliholidaysInRange = getHolidaysInRangeDate(startDate, endDate, inhabiles);
  const rangeDateWithState = createArrayBeetweenTwoDatesWithState(startDate, endDate, miliholidaysInRange);
    
  let enabledDateNext = {};
  if(!rangeDateWithState[0].isEnabled){
    enabledDateNext = rangeDateWithState.find(value =>{
      return value.isEnabled;
    })
  }else{
    enabledDateNext = rangeDateWithState[0];
  }
  const x = moment(enabledDateNext.date);
  if(x.isValid() && y.isValid() && x.isBefore(y)){
    return y.diff(x, 'days');
  }
}

function getHolidaysInRangeDate(startDate, endDate, inhabiles){
  const holidaysInRange = inhabiles.filter(value => {
    const val = new Date(value);
    return val.getTime() > startDate.getTime() && val.getTime() < endDate.getTime();
  })
  const miliholidaysInRange = holidaysInRange.map(value => {
    const date = new Date(value);
    return date.getTime();
  })
  return miliholidaysInRange;
}

function createArrayBeetweenTwoDatesWithState(start, end, miliholidaysInRange){
  var rangeArray = [];
  var currentDate = start;
  var stopDate = end;
  while(currentDate <= stopDate){
    currentDate.setHours(0,0,0,0);
    const fechaInfo = {
      isEnabled: true,
      date: currentDate.getTime()
    }
    if(miliholidaysInRange.includes(currentDate.getTime())){
      fechaInfo.isEnabled = false;
    }
    rangeArray.push(fechaInfo);
    currentDate.setDate( currentDate.getDate() + 1 );
  }
  return rangeArray;
}

function isValid(date) {
  return moment(date).isValid();
}

function addDays(today, days, utcHours=0) {
  let newDate = new Date(moment(today).add(days, 'days'));
  if(utcHours !== 0){
    newDate.setUTCHours(utcHours);
    newDate = new Date(newDate);
  }
  return newDate;
}


function stringToDate(stringArray, utcHours=0, inMilisecons=false, setHr=false ){
  const dateArray = stringArray.map(item => {

    let fecha = new Date(item); 

    if(setHr){
      fecha.setHours(0,0,0,0);
    }
    
    if(utcHours !== 0){
      fecha.setUTCHours(utcHours);
      fecha = new Date(fecha);
    }

    if(inMilisecons){
        return fecha.getTime();
    }else{
        return fecha;
    }
    
  })
  return dateArray;
}

export { countDays, isValid, addDays, calculateDefaultTimeLimit, getHolidaysDefault, stringToDate };
